<template>
	<div class="color-rectangle">
		<ColorRectangleSVG :skin="skin" class="color-rectangle__svg" />
		<div class="red-arrow-down" v-if="showArrow"></div>
		<div
			class="color-rectangle__text"
			:class="`color-rectangle__text--${skin}`"
		>
			{{ text }}
		</div>
	</div>
</template>

<script lang="ts" setup>
import ColorRectangleSVG from "@/components/SVG/ColorRectangleSVG.vue";
const { skin } = defineProps<{
	skin: "red" | "yellow";
	showArrow?: boolean;
	text: string;
}>();
</script>

<style lang="scss" scoped>
.color-rectangle {
	@include flex-row-center;
	position: relative;
	width: 6rem;
	height: 2rem;

	&__svg {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	&__text {
		z-index: 1;

		&--red {
			color: rgb(255, 61, 61);
		}
		&--yellow {
			color: rgb(255, 243, 221);
		}
	}

	.red-arrow-down {
		position: absolute;
		bottom: -0.5rem;
		left: 50%;
		transform: translateX(-50%);
		background: url($path-images + "backgrounds/fight-system/red-arrow-down.avif");
		background-size: cover;
		width: 0.75rem;
		height: 0.5rem;
	}
}
</style>
